export const TimeZoneConstants = [
  {
    abbreviation: 'NST',
    name: 'New Zealand Standard Time',
    rawOffsetInMinutes: 720,
    label: 'New Zealand Standard Time (GMT +12:00)',
    value: 'NST',
  },
  {
    abbreviation: 'SST',
    name: 'Solomon Standard Time',
    rawOffsetInMinutes: 660,
    label: 'Solomon Standard Time (GMT +11:00)',
    value: 'SST',
  },
  {
    abbreviation: 'AET',
    name: 'Australia Eastern Time',
    rawOffsetInMinutes: 600,
    label: 'Australia Eastern Time (GMT +10:00)',
    value: 'AET',
  },
  {
    abbreviation: 'ACT',
    name: 'Australia Central Time',
    rawOffsetInMinutes: 570,
    label: 'Australia Central Time (GMT +9:30)',
    value: 'ACT',
  },
  {
    abbreviation: 'JST',
    name: 'Japan Standard Time',
    rawOffsetInMinutes: 540,
    label: 'Japan Standard Time (GMT +9:00)',
    value: 'JST',
  },
  {
    abbreviation: 'CTT',
    name: 'China Taiwan Time',
    rawOffsetInMinutes: 480,
    label: 'China Taiwan Time (GMT +8:00)',
    value: 'CTT',
  },
  {
    abbreviation: 'VST',
    name: 'Vietnam Standard Time',
    rawOffsetInMinutes: 420,
    label: 'Vietnam Standard Time (GMT +7:00)',
    value: 'VST',
  },
  {
    abbreviation: 'BST',
    name: 'Bangladesh Standard Time',
    rawOffsetInMinutes: 360,
    label: 'Bangladesh Standard Time (GMT +6:00)',
    value: 'BST',
  },
  {
    abbreviation: 'IST',
    name: 'India Standard Time',
    rawOffsetInMinutes: 330,
    label: 'India Standard Time (GMT +5:30)',
    value: 'IST',
  },
  {
    abbreviation: 'PLT',
    name: 'Pakistan Lahore Time',
    rawOffsetInMinutes: 300,
    label: 'Pakistan Lahore Time (GMT +5:00)',
    value: 'PLT',
  },
  {
    abbreviation: 'NET',
    name: 'Near East Time',
    rawOffsetInMinutes: 240,
    label: 'Near East Time (GMT +4:00)',
    value: 'NET',
  },
  {
    abbreviation: 'MET',
    name: 'Middle East Time',
    rawOffsetInMinutes: 210,
    label: 'Middle East Time (GMT +3:30)',
    value: 'MET',
  },
  {
    abbreviation: 'EAT',
    name: 'Eastern African Time',
    rawOffsetInMinutes: 180,
    label: 'Eastern African Time (GMT +3:00)',
    value: 'EAT',
  },
  {
    abbreviation: 'CAT',
    name: 'Central African Time',
    rawOffsetInMinutes: 120,
    label: 'Central African Time (GMT +2:00)',
    value: 'CAT',
  },
  {
    abbreviation: 'EET',
    name: 'Eastern European Time',
    rawOffsetInMinutes: 120,
    label: 'Eastern European Time (GMT +2:00)',
    value: 'EET',
  },
  {
    abbreviation: 'ART',
    name: '(Arabic) Egypt Standard Time',
    rawOffsetInMinutes: 120,
    label: '(Arabic) Egypt Standard Time (GMT +2:00)',
    value: 'ART',
  },
  {
    abbreviation: 'ECT',
    name: 'European Central Time',
    rawOffsetInMinutes: 60,
    label: 'European Central Time (GMT +1:00)',
    value: 'ECT',
  },
  {
    abbreviation: 'WET',
    name: 'Western European Time',
    rawOffsetInMinutes: 0,
    label: 'Western European Time (GMT +0:00)',
    value: 'WET',
  },
  {
    abbreviation: 'AGT',
    name: 'Argentina Standard Time',
    rawOffsetInMinutes: -180,
    label: 'Argentina Standard Time (GMT -3:00)',
    value: 'AGT',
  },
  {
    abbreviation: 'BET',
    name: 'Brazil Eastern Time',
    rawOffsetInMinutes: -180,
    label: 'Brazil Eastern Time (GMT -3:00)',
    value: 'BET',
  },
  {
    abbreviation: 'CNT',
    name: 'Canada Newfoundland Time',
    rawOffsetInMinutes: -210,
    label: 'Canada Newfoundland Time (GMT -3:30)',
    value: 'CNT',
  },
  {
    abbreviation: 'PRT',
    name: 'Puerto Rico and US Virgin Islands Time',
    rawOffsetInMinutes: -240,
    label: 'Puerto Rico and US Virgin Islands Time (GMT -4:00)',
    value: 'PRT',
  },
  {
    abbreviation: 'EST',
    name: 'Eastern Standard Time',
    rawOffsetInMinutes: -300,
    label: 'Eastern Standard Time (GMT -5:00)',
    value: 'EST',
  },
  {
    abbreviation: 'IET',
    name: 'Indiana Eastern Standard Time',
    rawOffsetInMinutes: -300,
    label: 'Indiana Eastern Standard Time (GMT -5:00)',
    value: 'IET',
  },
  {
    abbreviation: 'CST',
    name: 'Central Standard Time',
    rawOffsetInMinutes: -360,
    label: 'Central Standard Time (GMT -6:00)',
    value: 'CST',
  },
  {
    abbreviation: 'MST',
    name: 'Mountain Standard Time',
    rawOffsetInMinutes: -420,
    label: 'Mountain Standard Time (GMT -7:00)',
    value: 'MST',
  },
  {
    abbreviation: 'PNT',
    name: 'Phoenix Standard Time',
    rawOffsetInMinutes: -420,
    label: 'Phoenix Standard Time (GMT -7:00)',
    value: 'PNT',
  },
  {
    abbreviation: 'PST',
    name: 'Pacific Standard Time',
    rawOffsetInMinutes: -480,
    label: 'Pacific Standard Time (GMT -8:00)',
    value: 'PST',
  },
  {
    abbreviation: 'AST',
    name: 'Alaska Standard Time',
    rawOffsetInMinutes: -540,
    label: 'Alaska Standard Time (GMT -9:00)',
    value: 'AST',
  },
  {
    abbreviation: 'HST',
    name: 'Hawaii Standard Time',
    rawOffsetInMinutes: -600,
    label: 'Hawaii Standard Time (GMT -10:00)',
    value: 'HST',
  },
  {
    abbreviation: 'MIT',
    name: 'Midway Islands Time',
    rawOffsetInMinutes: -660,
    label: 'Midway Islands Time (GMT -11:00)',
    value: 'MIT',
  },
];
